import React from "react";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { startCase } from "lodash";

const EmployeeView = ({ currentItem, setEmployeeView }) => {
  const { t } = useTranslation();
  return (
    <>
      <div className="items-center flex overflow-x-hidden justify-center overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="relative mx-auto max-w-3xl w-auto my-6 ">
          <form className="sm:py-4 py-8 px-7 sm:px-2 ">
            <div className="shadow-lg relative flex border-0 rounded-lg flex-col w-full bg-white outline-none focus:outline-none min-w-[940px] max-h-[96vh] overflow-y-auto	">
              <div className="flex justify-between p-5 items-center border-b border-solid border-slate-200 rounded-t">
                <h3 className="font-semibold text-xl ">{t("O_VIEW_USER")}</h3>
                <button onClick={() => setEmployeeView(false)} className=" ml-auto text-black border-2 rounded-full flex items-center justify-center h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none">
                  <span className="text-4xl text-[#B8BBBF] " title="Close">
                    ×
                  </span>
                </button>
              </div>
              <div className="flex-auto relative p-6 ">
                <h3 className="font-semibold text-xl">Employee details</h3>
                <div className="grid grid-cols-3">
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Employee ID</strong>
                      <h6>{currentItem?.Employee?.employeeId || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Employee name</strong>
                      <h6>{currentItem?.Employee?.name || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Email ID</strong>
                      <h6>{currentItem?.Employee?.email || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Year of experience</strong>
                      <h6>{currentItem.yearOfExperiece || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>DOB</strong>
                      <h6>{dayjs(currentItem?.Employee?.dob).format("MM-DD-YYYY ")} </h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Country</strong>
                      <h6>{currentItem.EmployeeCountry?.name || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>State</strong>
                      <h6>{currentItem.EmployeeState?.name || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>City</strong>
                      <h6>{currentItem.Employee?.city || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Skills</strong>
                      <h6>{currentItem.Skills?.map((item) => item?.name).join(", ") || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Job title</strong>
                      <h6>{currentItem.Job?.name || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Department</strong>
                      <h6>{currentItem.Department?.name || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Employment length (In days)</strong>
                      <h6>{currentItem.Job?.employmentLength || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Accepted and rejected date</strong>
                      <h6>{currentItem?.acceptedRejectedAt ? dayjs(currentItem?.acceptedRejectedAt).format("MM-DD-YYYY h:mm A") : "N/A"}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Form Status</strong>
                      <h6>{startCase(currentItem.formStatus) || "N/A"}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Duration Type</strong>
                      <h6>{currentItem.duration || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>LinkedIn</strong>
                      <h6>{currentItem.Employee?.linkedInLink ? (
                        <a href={currentItem.Employee.linkedInLink} target="_blank" rel="noopener noreferrer">
                          View Profile
                        </a>
                      ) : (
                        <span>LinkedIn profile not added</span>
                      )}</h6>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b">
                <button className="text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150" type="button" onClick={() => setEmployeeView(false)}>
                  {t("O_BACK")}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black" />
    </>
  );
};

export default EmployeeView;
